"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPostsCount = getPostsCount;
exports.getPosts = getPosts;
exports.getPost = getPost;
const config_1 = __importDefault(require("@src/config"));
const axios_1 = __importDefault(require("axios"));
const client = axios_1.default.create({
    baseURL: config_1.default.api,
    withCredentials: true,
    headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
    },
});
async function getPostsCount() {
    try {
        const response = await client.get('/0/cms/magazine-posts-count');
        return response.data;
    }
    catch (err) {
        throw err;
    }
}
async function getPosts(currentPage) {
    try {
        const response = await client.post('/0/cms/magazine-posts', {
            skip: (currentPage - 1) * config_1.default.magazine.postsPerPage,
        });
        return response.data;
    }
    catch (err) {
        throw err;
    }
}
async function getPost(options) {
    try {
        const response = await client.post('/0/cms/magazine-post', options);
        return response.data;
    }
    catch (err) {
        throw err;
    }
}
